<template>
<div class="chapter">
<div class="inner_page">
<p class="part"><a id="page_9"></a><a href="#/contents#tc2" id="ch2"> PART I</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?4f7bdf19